<script setup>
import { computed, useId } from 'vue';
import OptionSelect from 'dashboard/components-next/polaris/cards/OptionSelect.vue';
import { useFontSize } from 'dashboard/composables/useFontSize';

const props = defineProps({
  value: {
    type: String,
    default: 'default',
  },
  label: {
    type: String,
    default: '',
  },
  description: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['change']);

const { fontSizeOptions } = useFontSize();
// Phase 9.5: the kit's OptionSelect, as a setting row (words left, the choice right).
const labelId = `font-size-${useId()}`;
const options = computed(() =>
  fontSizeOptions.value.map(({ value, label }) => ({ value, label }))
);

const selectedValue = computed({
  get: () => props.value,
  set: value => {
    emit('change', value);
  },
});
</script>

<template>
  <div
    class="flex w-full flex-wrap items-start justify-between gap-x-4 gap-y-2"
  >
    <div class="min-w-0 flex-1 basis-48">
      <p :id="labelId" class="type-polaris-label">{{ label }}</p>
      <p class="type-polaris-caption text-polaris-muted-foreground">
        {{ description }}
      </p>
    </div>
    <OptionSelect
      v-model="selectedValue"
      :options="options"
      :aria-labelledby="labelId"
      class="w-full sm:w-48"
    />
  </div>
</template>
